<template>
  <o-card>
    <template slot="header">
      <h5 class="mb-0">{{ $t('sandoz.kam_item_proofs') }}</h5>
    </template>

    <p v-if="!kamItems.length" class="text-muted">{{ $t('sandoz.no_kam_items') }}</p>

    <table v-else class="table table-sm">
      <thead>
        <tr>
          <th>{{ $t('sandoz.product') }}</th>
          <th>{{ $t('sandoz.quantity') }}</th>
          <th>{{ $t('sandoz.price') }}</th>
          <th>{{ $t('sandoz.valid_from') }}</th>
          <th>{{ $t('sandoz.valid_to') }}</th>
          <th>{{ $t('sandoz.proof_sample_size') }}</th>
          <th>{{ $t('sandoz.proof_address_connection') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="kamItem in kamItems" :key="kamItem.id || kamItem.product_id">
          <td>{{ kamItem.product_name || (kamItem.product && kamItem.product.name) }}</td>
          <td>{{ kamItem.quantity }}</td>
          <td>{{ kamItem.price }}</td>
          <td>{{ kamItem.valid_from }}</td>
          <td>{{ kamItem.valid_to }}</td>
          <td>{{ kamItem.proof_sample_size }}%</td>
          <td>{{ kamItem.address_connection || 'all' }}</td>
        </tr>
      </tbody>
    </table>

    <h6 class="mt-3">{{ $t('sandoz.proof_pictures') }}</h6>
    <p class="text-muted small">{{ $t('sandoz.proof_pictures_phase4_note') }}</p>
    <div v-if="proofPictures.length" class="d-flex flex-wrap">
      <a v-for="pic in proofPictures" :key="pic.id" :href="pic.url || pic.path" target="_blank"
         class="mr-2 mb-2 d-inline-block">
        <img :src="pic.thumbnail_url || pic.url || pic.path" alt="" style="max-width:120px;max-height:120px;"/>
      </a>
    </div>
  </o-card>
</template>

<script>
import sectionMixin from '../sectionMixin'

/**
 * KAM item proofs and pictures. The full edit-proof modal (editProof / updateProofItem) from
 * kam/ContractDetail.vue stays in the legacy page during this phase — here we render the
 * read-only summary so the section is visible end-to-end.
 */
export default {
  name: 'SectionKamItemProofs',
  mixins: [sectionMixin],
  computed: {
    kamItems() {
      return Array.isArray(this.item.kam_items) ? this.item.kam_items : []
    },
    proofPictures() {
      const all = []
      this.kamItems.forEach(ki => {
        if (Array.isArray(ki.proofs)) {
          ki.proofs.forEach(proof => {
            if (Array.isArray(proof.pictures)) {
              all.push(...proof.pictures)
            }
          })
        }
      })
      return all
    }
  }
}
</script>
